import React from 'react'

import { TableContainer, Table } from '@material-ui/core'
import {
  DetailPanelAction,
  DetailPanelHeader,
  DetailPanelBody,
  DetailPanelFooter
} from './DetailPanelContents/DetailPanelContents'
import withTranslate from 'react-redux-multilingual/lib/withTranslate'

const DetailPanel = ({
  rowData,
  targetScore,
  frequencyOptions,
  responsibleSearchChanged,
  applyButtonClicked,
  inputChanged,
  translate,
  appraisalType,
  loadingQueue
}) => {
  let rowDetail = null
  const frequencyType = frequencyOptions.find(
    item => item.value_list_id === rowData.frequency_type_id
  )
  const detailList = rowData?.result_kpi || {}
  const kpiTypeDate = !!rowData?.uom?.is_date
  const adopted = !!rowData.is_adopt

  rowDetail = (
    <DetailPanelBody
      adopted={adopted}
      detailList={detailList}
      rowChanged={updatedRow => {
        let updatedResults = []
        if (rowData.result_kpi) {
          updatedResults = [...rowData.result_kpi]
          const updatedResultItem = rowData.result_kpi.find(
            result => +result.frequency_no === +updatedRow.frequency_no
          )
          if (updatedResultItem) {
            updatedResults = updatedResults.map(item => {
              if (+item.frequency_no === +updatedRow.frequency_no) {
                return updatedRow
              }
              return item
            })
          } else {
            updatedResults = [...updatedResults, updatedRow]
          }
        } else {
          updatedResults = [updatedRow]
        }
        inputChanged({ ...rowData, result_kpi: updatedResults })
      }}
      frequencyCode={frequencyType?.value_list_code}
      kpiTypeDate={kpiTypeDate}
      targetScore={targetScore}
      translate={translate}
    />
  )
  return (
    <TableContainer style={{ maxHeight: 300, overflow: 'auto' }}>
      <Table stickyHeader>
        <DetailPanelAction applyButtonClicked={applyButtonClicked} translate={translate} />
        <DetailPanelHeader translate={translate} />
        {rowDetail}
        <DetailPanelFooter
          appraisalType={appraisalType}
          // responsibleList={responsibleOptions}
          loadingQueue={loadingQueue}
          responsibleSearchChanged={responsibleSearchChanged}
          rowData={rowData}
          inputChanged={updatedRow => inputChanged(updatedRow)}
          translate={translate}
          adopted={adopted}
        />
      </Table>
    </TableContainer>
  )
}

export default withTranslate(DetailPanel)
